import * as actionTypes from "./actionTypes";

/**
 * Sets an entire dictionary to store.costs.retrainCostDetails
 */
export const setRetrainCostDetail = (value) => {
  return {
    type: actionTypes.SET_RETRAIN_COST_DETAIL,
    value,
  };
};

/**
 * Appends/updates item in store.costs.retrainCostDetails.roles.
 * obj must have three keys: {role, attr, value}
 */
export const setRetrainCostForRoleAttr = (obj) => {
  return {
    type: actionTypes.SET_RETRAIN_COST_FOR_ROLE_ATTR,
    obj,
  };
};

/**
 * Appends/updates key-value pair in store.costs.retrainCostDetails except for the key of 'roles'
 * obj {key: value}
 */
export const setRetrainCostCommonAttr = (obj) => {
  return {
    type: actionTypes.SET_RETRAIN_COMMON_ATTR,
    obj,
  };
};

/**
 * Sets an entire dictionary to store.costs.prodLoss
 */
export const setProdLoss = (value) => {
  return {
    type: actionTypes.SET_PROD_LOSS,
    value,
  };
};

/**
 * Appends/updates key-value pair in store.costs.prodLoss
 * obj {key: value}
 */
export const setProdLossAttr = (obj) => {
  return {
    type: actionTypes.SET_PROD_LOSS_ATTR,
    obj,
  };
};

/**
 * sets an entire dictionary to store.costs.systemCostDetails
 */
export const setSystemCost = (value) => {
  return {
    type: actionTypes.SET_SYSTEM_COST,
    value,
  };
};

/**
 * Appends/updates a key-value pair in store.costs.systemCostDetails
 * obj {key: value}
 */
export const setSystemCostAttr = (obj) => {
  return {
    type: actionTypes.SET_SYSTEM_COST_ATTR,
    obj,
  };
};

/**
 * Sets an entire dictionary to store.costs.costAdjustDetails
 */
export const setCostAdjust = (value) => {
  return {
    type: actionTypes.SET_COST_ADJUST,
    value,
  };
};

/**
 * Appends/updates key-value pair in store.costs.costAdjustDetails
 */
export const setCostAdjustAttr = (obj) => {
  return {
    type: actionTypes.SET_COST_ADJUST_ATTR,
    obj,
  };
};

export const clearCosts = () => {
  return {
    type: actionTypes.CLEAR_COSTS,
  };
};
